import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "winner-board-wrap" }
const _hoisted_2 = { class: "jackpot-wrap" }
const _hoisted_3 = { class: "jackpot-value" }
const _hoisted_4 = { class: "winner-list-border" }
const _hoisted_5 = { class: "winner-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "game-content" }
const _hoisted_8 = { class: "game-reward flex justify-end" }

import { ref, onMounted } from 'vue';
import { queryWinnerBoard } from '@/api';


export default {
  __name: 'WinnerBoard',
  setup(__props) {

const dataList = ref([]);
const total = ref(0);

onMounted(() => {
  fetchWinnerBoard();
})

const fetchWinnerBoard = () => {
  queryWinnerBoard({ pageSize: 8 }).then((res) => {
    const { jackpot, gameInfoList } = res.data || {}
    dataList.value = gameInfoList || [];
    total.value = jackpot || 0;
  })
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_loading = _resolveComponent("van-loading")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          class: "currency-icon",
          src: require('@/assets/img/common/currency.png')
        }, null, 8, ["src"]),
        _createTextVNode(_toDisplayString(_ctx.$filter.outputAmount(total.value, 0)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "game-block flex",
            key: item.id,
            onClick: $event => (_ctx.doEnterGame({ gid: item.gid }, { title: item.name }))
          }, [
            _createVNode(_component_van_image, {
              class: "game-img",
              fit: "cover",
              src: item.icon || '-',
              "error-icon": require('@/assets/img/game/game.png')
            }, {
              loading: _withCtx(() => [
                _createVNode(_component_van_loading, {
                  type: "spinner",
                  color: "#ADB5BF",
                  size: "24"
                })
              ]),
              _: 2
            }, 1032, ["src", "error-icon"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(item.username), 1),
              _createElementVNode("div", null, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_image, {
                class: "currency-icon",
                src: require('@/assets/img/common/currency.png')
              }, null, 8, ["src"]),
              _createTextVNode(_toDisplayString(_ctx.$filter.outputAmount(item.amount, 0)), 1)
            ])
          ], 8, _hoisted_6)), [
            [_directive_audio]
          ])
        }), 128)),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "blank-block" }, null, -1))
      ])
    ])
  ]))
}
}

}